/* c-lp-find-my-part.js — progressive enhancement for sections/c-lp-find-my-part.liquid.
   Without it every brand table renders in full (BVA's cloak strips scripts on desktop Linux).
   With it: reveal the [hidden] finder, narrow rows by brand and typed model in place (no request,
   no reload) and announce the count through the form's aria-live status. No dependencies. */
(() => {
  const SELECTOR = '[data-sl-id="c-lp-find-my-part"]';

  // lower-case, unify hyphen/dash variants ("S2000–S8999" matches "s2000-s8999"), collapse spaces
  const normalize = (value) => (value || '').toLowerCase().replace(/[‐-―]/g, '-').replace(/\s+/g, ' ').trim();

  // "Upright Vacuums: R27 Series (R27D, R27P), R25 Series" -> ["R27 Series (R27D, R27P)", "R25 Series"]
  const splitModels = (text) => {
    const parts = [];
    let depth = 0;
    let current = '';
    for (const char of text) {
      if (char === '(') depth += 1;
      if (char === ')') depth = Math.max(0, depth - 1);
      if (char === ',' && depth === 0) {
        parts.push(current);
        current = '';
      } else {
        current += char;
      }
    }
    parts.push(current);
    return parts
      .map((part) => part.replace(/^[^:()]*:\s*/, '').replace(/\s+/g, ' ').trim())
      .filter((part) => part && part.length <= 40);
  };

  function init(root) {
    const form = root.querySelector('[data-fmp-form]');
    if (!form || root.dataset.fmpBound === 'true') return;
    root.dataset.fmpBound = 'true';

    const brand = form.querySelector('[data-fmp-brand]');
    const model = form.querySelector('[data-fmp-model]');
    const list = form.querySelector('[data-fmp-models]');
    const status = form.querySelector('[data-fmp-status]');
    const groups = Array.from(root.querySelectorAll('[data-fmp-group]'));
    const rows = groups.flatMap((group) =>
      Array.from(group.querySelectorAll('[data-fmp-row]')).map((row) => ({
        group,
        row,
        text: normalize(row.textContent),
        models: splitModels((row.querySelector('[data-fmp-models-cell]') || row).textContent),
      })),
    );

    const fillModelList = () => {
      const seen = new Set();
      list.replaceChildren();
      rows.forEach(({ group, models }) => {
        if (brand.value && group.dataset.brand !== brand.value) return;
        models.forEach((name) => {
          if (seen.has(name)) return;
          seen.add(name);
          const option = document.createElement('option');
          option.value = name;
          list.append(option);
        });
      });
    };

    const apply = () => {
      const brandValue = brand.value;
      const query = normalize(model.value);
      const filtering = Boolean(brandValue || query);
      let total = 0;

      groups.forEach((group) => {
        const brandMatches = !brandValue || group.dataset.brand === brandValue;
        let visible = 0;
        rows.forEach((entry) => {
          if (entry.group !== group) return;
          const show = brandMatches && (!query || entry.text.includes(query));
          entry.row.hidden = !show;
          if (show) visible += 1;
        });
        group.hidden = filtering && visible === 0;
        total += visible;
      });

      const { statusOne = '', statusMany = '', statusNone = '' } = form.dataset;
      let message = '';
      if (filtering) {
        if (total === 0) message = statusNone;
        else if (total === 1) message = statusOne;
        else message = statusMany.replace('[count]', String(total));
      }
      if (status.textContent !== message) status.textContent = message;
      root.classList.toggle('is-filtering', filtering);
    };

    brand.addEventListener('change', () => {
      fillModelList();
      apply();
    });
    model.addEventListener('input', apply);
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      apply();
    });
    form.addEventListener('reset', () => {
      // the reset event fires before the controls are cleared
      window.setTimeout(() => {
        fillModelList();
        apply();
      }, 0);
    });

    fillModelList();
    form.hidden = false;
    root.classList.add('is-js-ready');
  }

  const initAll = (scope) => scope.querySelectorAll(SELECTOR).forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document));
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
